// import lazyLoading from '../lazyLoading';

export default {
  name: 'contact',
  caption: 'contact',
  wdm16_id: '7124',
  icon: 'icon-cursor',
  path: '/contact',
  // component: lazyLoading('patient/index'),
  required: [],
  permissions: [],
  meta: {
    required: [],
    icon: 'fa-bars',
    expanded: false
  }
};
